import { PublicClientApplication } from "@azure/msal-browser";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

const AuthService = () => {
  const acquireToken = async (msalInstance: PublicClientApplication) => {
    const activeAccount = msalInstance.getActiveAccount();
    const accounts = msalInstance.getAllAccounts();

    if (!activeAccount && accounts.length === 0) {
      /*
       * User is not signed in. Throw error or wait for user to login.
       * Do not attempt to log a user in outside of the context of MsalProvider
       */
    }

    const request = {
      scopes: [
        "openid",
        "https://foundatb2c.onmicrosoft.com/9074661a-3f28-4601-9f69-7f5ff455ae63/API_Access",
      ],
      account: activeAccount || accounts[0],
    };

    try {
      const response = await msalInstance.acquireTokenSilent(request);

      if (!response.accessToken || response.accessToken === "") {
        throw new InteractionRequiredAuthError();
      }
      // Check if the token is about to expire (e.g., within the next 5 minutes)
      if (!response || !response.expiresOn) {
        return null;
      }

      const expiresOn =
        response.expiresOn instanceof Date
          ? response.expiresOn
          : new Date(response.expiresOn);

      if (expiresOn.getTime() - Date.now() < 300000) {
        // Token is about to expire, refresh it
        const popupResponse = await msalInstance.acquireTokenRedirect(request);
      }

      // Token is still valid
      return response.accessToken;
    } catch (error) {
      // Silent acquire failed, fallback to interactive acquisition
      const popupResponse = await msalInstance.acquireTokenRedirect(request);
    }
  };

  return { acquireToken };
};

export default AuthService;
